import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_SQUARE_CHECK_BIG: GlameraIconDefinition = {
  name: 'square-check-big',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-square-check-big-frame" d="M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5"></path>
    <path class="glm-square-check-big-check" d="m9 11 3 3L22 4"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-square-check-big-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './square-check-big.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class SquareCheckBigIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_SQUARE_CHECK_BIG;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
